import { Spacer, Text } from '@loomhq/lens';
import React from 'react';

import styles from './styles.module.less';

const NewExperienceTag = ({ children, showNewExperience = false }) => {
  return (
    <>
      <div className="flex items:center">
        {showNewExperience && (
          <Spacer right={1}>
            <div className={styles.newTag}>
              <Text size="small" fontWeight="bold">
                New!
              </Text>
            </div>
          </Spacer>
        )}
        {children}
      </div>
    </>
  );
};

export default NewExperienceTag;
